import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { useMutationWithToaster } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export function useUseCasesWidgetVisibility() {
  const mutationFactory = useCallback(() => {
    const query = `mutation updateUseCasesWidgetVisibility($visible: Boolean!) {
          updateUseCasesWidgetVisibility(visible: $visible) {
            visible
          }
        }`;

    const resolver = ({ data: { updateUseCasesWidgetVisibility } }) => {
      return { data: updateUseCasesWidgetVisibility.visible };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const dispatch = useDispatch();

  const [updateUseCaseVisibility, { loading }] = useMutationWithToaster(
    mutationFactory,
    {
      onDone: (data) => {
        dispatch({
          type: "SET_HUB_USE_CASES_VISIBILITY",
          visible: data,
        });
      },
    }
  );

  return {
    isUpdatingUseCaseVisibility: loading,
    updateUseCaseVisibility: async (visible) => {
      return updateUseCaseVisibility(
        { visible },
        {
          successMsg: visible
            ? "Welcome to Hubly will now be visible in your workspace"
            : "Welcome to Hubly will not be visible in your workspace anymore",
          defaultErrorMsg:
            "Failed to update use case visibility. Please retry or contact support for assistance.",
        }
      );
    },
  };
}
export default useUseCasesWidgetVisibility;
